import {ChangeEvent, FC, useState} from 'react'
import {useDispatch} from 'react-redux'
import {setNewPasswordModalOpen, useNewPasswordModal} from 'entities/app'
import {FormInput} from 'entities/inputs'
import {ChangePassword} from 'entities/user'
import {isPasswordValid, PASSWORD_MIN_CHAR_ERROR_TEXT} from 'shared/lib'
import {Button} from 'shared/ui/buttons'
import {Close} from 'shared/ui/icons'
import {AuthModal} from 'shared/ui/modals'
import sharedStyles from 'shared/ui/styles/authModals.module.scss'
import customStyles from '../signInModal/styles.module.scss'


export const NewPasswordModal: FC = () => {
  const dispatch = useDispatch()
  const isOpen = useNewPasswordModal()
  const [newPassword, setNewPassword] = useState({password: '', confirmPassword: ''})
  const [error, setError] = useState({password: '', confirmPassword: ''})
  const [isLoading, setIsLoading] = useState(false)

  const onChangeHandler = (e: ChangeEvent<HTMLInputElement>) => {
    setError({password: '', confirmPassword: ''})
    setNewPassword((prev: any) => ({...prev, [e.target.name]: e.target.value}))
  }

  const closeModal = () => dispatch(setNewPasswordModalOpen(false))

  const onClickHandler = () => {
    if (!newPassword.confirmPassword && !newPassword.password) return setError({password: ' ', confirmPassword: ' '})
    if (!newPassword.confirmPassword) return setError(prev => ({...prev, confirmPassword: ' '}))
    if (!newPassword.password) return setError(prev => ({...prev, password: ' '}))

    if (newPassword.password !== newPassword.confirmPassword)
      return setError({password: ' ', confirmPassword: 'Password do not match'})
    if (!isPasswordValid(newPassword.password))
      return setError(prevState => ({...prevState, password: PASSWORD_MIN_CHAR_ERROR_TEXT}))
    if (!isPasswordValid(newPassword.confirmPassword))
      return setError(prevState => ({...prevState, confirmPassword: PASSWORD_MIN_CHAR_ERROR_TEXT}))

    setIsLoading(true)

    ChangePassword(newPassword.password)
      .then(closeModal)
      .catch((e) => setError((prevState) => ({...prevState, password: e.error || e.message || 'Unexpected error'})))
      .finally(() => setIsLoading(false))
  }

  if (!isOpen) return <></>

  return (
    <AuthModal>
      <div onClick={closeModal} className={customStyles.modal__close}>
        <Close />
      </div>
      <div className={customStyles.modal}>
        <p className={customStyles.modal__title}>New password</p>
        <FormInput
          onChange={onChangeHandler}
          value={newPassword.password}
          type='password'
          name='password'
          label='Password'
          placeholder='Your password'
          errorText={error.password}
          isError={Boolean(error.password)}
        />
        <FormInput
          onChange={onChangeHandler}
          value={newPassword.confirmPassword}
          type='password'
          name='confirmPassword'
          label='Confirm password'
          placeholder='Your password'
          errorText={error.confirmPassword}
          isError={Boolean(error.confirmPassword)}
        />
        <Button
          isLoading={isLoading}
          isDisabled={isLoading}
          onClick={onClickHandler}
          type='submit'
          className={sharedStyles.modal__signIn}
          fullwidth
          styleType='primary'
        >
          Reset password
        </Button>
      </div>
    </AuthModal>
  )
}